export enum TreatmentPlanStepStatus {
  DRAFT = "DRAFT",
  PLANNED = "PLANNED",
  PIN_DONE = "PIN_DONE",
  INSTRUCTION_DONE = "INSTRUCTION_DONE",
}
